/**
 * Free/premium packaging line item added by MAO. Not a real purchased product:
 * it has no PDP (clicking it 404s, RP-6002) and should not count towards the
 * order's displayed item count (RP-6061).
 */
export const PACKAGING_PRODUCT_CODE = 'PREMIUMPACK01'

/**
 * Physical gift card line item. Has no PDP (clicking it 404s, RP-6111).
 *
 * TODO(RP-6111): confirm this classCode against the Order History API payload
 * for a real physical gift card order before merge.
 */
export const PHYSICAL_GIFTCARD_CLASS_CODE = 'GIFTCARD'

/**
 * E-gift card line item. Also has no PDP (clicking it 404s, RP-6111, order
 * 0200780678) — same fix as the physical gift card, just a different
 * classCode. Also referenced in `api/ordersApi.ts` for image URL cleanup.
 */
export const E_GIFTCARD_CLASS_CODE = 'EGIFTCARD'
